// extracted by mini-css-extract-plugin
module.exports =  {"root":"HistoryGroupLoader-module__root--KsUZ6","flexColumn":"HistoryGroupLoader-module__flexColumn--G5uL1"};